import { useMutation } from '@tanstack/react-query'
import { Toast } from 'ui/components/Toast'

import { handlerServerError } from '@orbit/errors'

import * as Service from '../../service'

export const useCTRsGeneration = () =>
  useMutation({
    mutationFn: (date: string) => Service.CTR.generateCTRs({ date }),
    onError: (error) => handlerServerError(error),
    onSuccess: () => {
      Toast.infoSmall(
        'The generation process has started successfully. It may take some time. Please refresh the page later.'
      )
    }
  })
